var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTest2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.7104 127.58L75.7003 143.59C76.6903 151.39 74.2204 159.55 68.2204 165.55C60.1204 173.65 48.0504 175.34 38.2704 170.67L55.8104 153.13C59.2404 149.7 59.2404 144.14 55.8104 140.72C52.3804 137.29 46.8204 137.29 43.4004 140.72L25.8604 158.26C21.1904 148.47 22.8804 136.41 30.9804 128.31C36.9704 122.32 45.1303 119.84 52.9403 120.83L75.2403 98.53M127.58 91.7L143.59 75.69C151.39 76.68 159.55 74.21 165.55 68.21C173.65 60.11 175.34 48.04 170.67 38.26L153.13 55.8C149.7 59.23 144.14 59.23 140.72 55.8C137.29 52.37 137.29 46.81 140.72 43.39L158.26 25.85C148.47 21.18 136.41 22.87 128.31 30.97C122.32 36.96 119.84 45.12 120.84 52.93L100.05 73.72",
    stroke: "url(#paint0_linear_285_3851)",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9292 110.47L110.475 88.924C110.807 88.5917 111.352 88.5846 111.691 88.924L176.313 153.547C176.851 154.084 176.851 154.961 176.313 155.498L155.51 176.301C154.973 176.839 154.096 176.839 153.559 176.301L88.9362 111.679C88.6039 111.346 88.5968 110.802 88.9362 110.463L88.9292 110.47Z",
    stroke: "#232F3E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.6 93.8L69.2302 57.28C68.2402 56.28 67.5002 55.07 67.0702 53.73L62.0602 38.12C61.3002 35.74 59.5602 33.78 57.2802 32.75L40.1502 24.98C36.7902 23.45 32.8302 24.17 30.2102 26.79L26.7902 30.21C24.1802 32.82 23.4602 36.78 24.9802 40.15L32.7502 57.28C33.7802 59.56 35.7302 61.3 38.1202 62.06L55.7602 67.72L93.7902 105.6",
    stroke: "#232F3E",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_285_3851",
    x1: 21.2904,
    y1: 98.27,
    x2: 175.25,
    y2: 98.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2074D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46EBB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest2);
export default __webpack_public_path__ + "static/media/test2.095a32e22cacdcc4f9ad45c15e845cc2.svg";
export { ForwardRef as ReactComponent };